import { type DataTablePreferenceProfileSettingsType } from "./types";

export const dataTablePreferencesApi = "/view-preferences";

/**
 * TODO: BE needs to be implemented in iq-framework, now works only for udzs project
 *
 * @param api - data table API endpoint (e.g. /api/pip/...)
 * @returns the API endpoint for data table preferences (e.g. /api/pip/view-preferences)
 */
export function createDataTablePreferencesApi(api: string) {
  const apiBase = `/${api.split("/").filter(Boolean).slice(0, 2).join("/")}`;

  return `${apiBase}${dataTablePreferencesApi}`;
}

export function viewPreferencesKey(tableId: string) {
  return ["view-preferences", tableId] as const;
}

export function parsePreferenceSettings(settings: string) {
  return JSON.parse(settings) as DataTablePreferenceProfileSettingsType;
}
